import React from "react";
import { Product } from "../Product";
import './ProductList.css';
import { Spinner } from "../Spinner";
import { useSettings } from "../Context/SettingsContext";

function ProductList({ title, products, loading, location })
{  
  const [selectedReference, setSelectedReference] = React.useState(null);
  const settings = useSettings();

    React.useEffect(() => {   
    setSelectedReference(null);
    }, [location]);

    const handleProductClick = (reference) => {   
      setSelectedReference(reference);
    };

  if(loading) {
    return(
      <div className="product-list-container">
        <h2 className="product-list-title">{title}</h2>
        <Spinner></Spinner>
      </div>
    );
  }

    return (
        <div className="product-list-container">
          { selectedReference ? (
            <Product referenceP={selectedReference} onBack={() => setSelectedReference(null)} />
          ) : (
            <>
              <h2 className="product-list-title">{title}</h2>
              <div className="product-grid">

                {products.map((product) => (
                
                  <div 
                    key={product.reference}
                    className="product-card"
                    onClick={() => handleProductClick(product.reference)}
                  >
                    <img src={product.imageUrl} alt={product.name} className="product-image" loading="lazy"/>                               
                    
                    <div className="product-info">
                    <p className="product-list-name">{product.name}</p>                                     
                    <p className="product-list-additional">{product.additionalTitle}</p>
                    <p className="product-list-price">$ {product.price.toLocaleString()}</p>
                    </div>              

                  </div>
                  
                ))}

              </div>
            </>
          )}
        </div>
      );
}

export { ProductList };